var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustryEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_832_490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.97 82.3567L109.676 73.0618V41.1795L115.744 38.9918C117.137 38.4894 118.066 37.1683 118.067 35.6872C118.068 34.2066 117.141 32.8837 115.748 32.3796L60.2303 12.2735C59.4571 11.9935 58.6095 11.9935 57.8364 12.2735L2.31847 32.3796C0.931339 32.882 0.00564611 34.1967 2.16508e-05 35.672C-0.00513411 37.1472 0.91095 38.4687 2.2941 38.9813L22.7833 46.5713V69.7384C22.7833 70.4574 23.0036 71.1593 23.4149 71.7489C23.641 72.0733 25.7833 74.9987 31.268 77.7594C38.1971 81.2475 47.2853 83.0161 58.2798 83.0161C69.2662 83.0161 78.4003 81.2512 85.4283 77.7699C90.9673 75.0263 93.1807 72.1314 93.4151 71.8106C93.8538 71.209 94.0902 70.4837 94.0902 69.7389V46.7981L102.645 43.7138V73.0618L93.3504 82.3567C92.6912 83.0159 92.3206 83.91 92.3206 84.8422C92.3206 85.7745 92.6909 86.6687 93.3504 87.3277L102.645 96.6224V104.421C102.645 106.362 104.219 107.936 106.161 107.936C108.102 107.936 109.676 106.362 109.676 104.421V96.6224L118.971 87.3277C120.343 85.9554 120.343 83.7293 118.97 82.3567ZM59.0334 19.3175L104.207 35.6774L58.2964 52.2295L13.7357 35.7221L59.0334 19.3175ZM87.0594 68.3375C75.0421 79.1509 39.3319 77.911 29.8139 68.3726V49.1758L57.0585 59.2685C57.4909 59.3369 57.8992 59.7098 59.4719 59.2793L87.0597 49.3333L87.0594 68.3375ZM106.16 90.1953L100.807 84.8422L106.16 79.4889L111.513 84.8422L106.16 90.1953Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_832_490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryEducation);
export default __webpack_public_path__ + "static/media/industry_Education.b8774c4ed1c978a066f43eb6cf39a560.svg";
export { ForwardRef as ReactComponent };